import React, {Component} from 'react';
import Styles from './style.css';
import {Link} from 'react-router-dom';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import HeaderMobileMenu from "../header-mobile-menu/component";
import {cartRegister} from "../../services/cartRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {imagesRegister} from "../../services/imagesRegister";
import ModalLang from "../modal-lang/component";
import ModalLeave from "../modal-leave/component";
import {marketRegister} from "../../services/marketRegister";
import {demoRegister} from "../../services/demoRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class HeaderSignUpTwo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            user: {},
            modal: false,
            lang: null,
            dropdown: false,
            temp_lang: null,
            language: false,
            leave: false,
            home: false,
            profile: false,
            languages: []
        };
        this._lang = this._lang.bind(this);
        this._leave = this._leave.bind(this);
    };

    componentWillMount() {
        this._updateUser();
        this._updateStep();
        this._updateLang();
        this._updateLanguages();
    }

    _updateLang(){
        this.setState({lang: langRegister.lang()});
    }

    _updateUser() {
        let user = userRegister.get();
        if(user){
            this.setState({
                user: user
            });
        }
    }

    _updateStep() {
        try {
            if (this.props.step) {
                this.setState({step: this.props.step});
            }
        } catch (error) {}
    }

    _updateLanguages() {
        let languages = JSON.parse(salesChannelRegister.get("languages"))?JSON.parse(salesChannelRegister.get("languages")):[];
        this.setState({languages: languages});
    }

    _profile(){
        try {
            this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/user/campaigns/running");
        } catch (e) {}
    }

    _signout() {
        if(this.state.user.email){
            if(this.state.user.admin){
                this.setState({home: true, leave: true, logout: true});
            }else{
                demoRegister.remove();
                userRegister.remove();
                tokenRegister.remove();
                window.location.reload();
            }
        }else{
            demoRegister.remove();
            userRegister.remove();
            tokenRegister.remove();
            window.location.reload();
        }
    }

    _openMenu () {
        this.child._openMenu();
    }

    _login() {
        try {
            this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/login?from_path=" + this.props.props.location.pathname);
        } catch (error) {}
    }

    _lang(lang){
        if(lang){
            langRegister.set(lang);
            cartRegister.remove();
            quotesRegister.remove();
            imagesRegister.remove();
            if(this.props.props.location.pathname.indexOf("image") !== -1){
                this.props.props.history.replace("/" + marketRegister.code() + "/" + langRegister.lang() + "/signup/image");
                window.location.reload();
            }else{
                this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/signup/image");
            }
        }else{
            this.setState({language: false});
        }
    }

    _setLang(prop){
        if(this.props.props.location.pathname.indexOf("signup") !== -1){
            this.setState({language: true, temp_lang: prop, dropdown: false}, () => {});
        }else{
            let string = "/" + marketRegister.code() + "/" + langRegister.lang();
            let re = new RegExp(string,"g");
            let url = this.props.props.location.pathname.replace(re,'');
            langRegister.set(prop);
            this.props.props.history.replace("/" + marketRegister.code() + "/" + langRegister.lang() + url);
            window.location.reload();
        }
    }

    _leave(value){
        if(value){
            if(this.state.home){
                try {
                    if(this.state.user.admin){
                        if(this.state.logout){
                            tokenRegister.remove();
                            userRegister.remove();
                            demoRegister.remove();
                        }
                        imagesRegister.remove();
                        cartRegister.remove();
                        quotesRegister.remove();
                    }
                }catch (error){}
                try {
                    this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang());
                } catch (e) {}
            }else if(this.state.profile){
                this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/user/campaigns/running");
            }else{
                if(this.props.props.location.pathname.indexOf("image") !== -1){
                    window.location.reload();
                }else{
                    this.props.props.history.push("/" + marketRegister.code() + "/" + langRegister.lang() + "/signup/image");
                }
            }
        }else{
            this.setState({leave: false});
        }
    }

    _renderText(item) {
        return langRegister.get("signup-header-two", item);
    }

    render() {
        return (
            <div>
                {
                    this.state.language &&
                    <ModalLang setLang={this._lang} lang={this.state.temp_lang} props={this.props}/>
                }
                {
                    this.state.leave &&
                    <ModalLeave setLeave={this._leave} props={this.props}/>
                }
                <div className={Styles.header}>
                    {
                        this.state.dropdown &&
                        <div onClick={() => this.setState({dropdown: false})} className={Styles.languageButtonContainerOverlay}/>
                    }
                    <div className={Styles.logoContainer}>
                        <img onClick={() => this.setState({leave: true, home: true})} className={Styles.logoContainerIcon}
                             src={require("../../assets/images/logo.svg")}/>
                        <img onClick={() => this.setState({leave: true, home: true})} className={Styles.logoContainerIconMobile}
                             src={require("../../assets/images/logo_mobile.svg")}/>
                    </div>
                    <div className={Styles.progressContainer}>
                        <div className={Styles.progressContainerInner}>
                            <div className={Styles.progressContainerLine}/>
                            <div className={Styles.progressContainerItem}>
                                <img className={Styles.progressContainerItemIcon}
                                     src={require("../../assets/images/checkmark_active.svg")}/>
                                <div className={Styles.progressContainerItemText}>
                                    {this._renderText("item_1")}
                                </div>
                            </div>
                            <div className={Styles.progressContainerItem}>
                                {
                                    this.state.step < 2 &&
                                    <div
                                        className={
                                            cx(Styles.progressContainerItemCircle,
                                                {
                                                    [Styles.progressContainerItemCircleActive]: this.state.step === 1
                                                })
                                        }
                                    />
                                }
                                {
                                    this.state.step > 1 &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active.svg")}/>

                                }
                                <div
                                    className={
                                        cx(Styles.progressContainerItemText,
                                            {
                                                [Styles.progressContainerItemTextActive]: this.state.step === 1,
                                            })
                                    }
                                >
                                    {this._renderText("item_2")}
                                </div>
                            </div>
                            <div className={Styles.progressContainerItem}>
                                {
                                    this.state.step < 3 &&
                                    <div
                                        className={
                                            cx(Styles.progressContainerItemCircle,
                                                {
                                                    [Styles.progressContainerItemCircleActive]: this.state.step === 2
                                                })
                                        }
                                    />
                                }
                                {
                                    this.state.step > 2 &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active.svg")}/>
                                }
                                <div
                                    className={
                                        cx(Styles.progressContainerItemText,
                                            {
                                                [Styles.progressContainerItemTextActive]: this.state.step === 2,
                                            })
                                    }
                                >
                                    {this._renderText("item_3")}
                                </div>
                            </div>
                            <div className={Styles.progressContainerItem}>
                                {
                                    this.state.step < 4 &&
                                    <div
                                        className={
                                            cx(Styles.progressContainerItemCircle,
                                                {
                                                    [Styles.progressContainerItemCircleActive]: this.state.step === 3
                                                })
                                        }
                                    />
                                }
                                {
                                    this.state.step > 3 &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active.svg")}/>
                                }
                                <div
                                    className={
                                        cx(Styles.progressContainerItemText,
                                            {
                                                [Styles.progressContainerItemTextActive]: this.state.step === 3,
                                            })
                                    }
                                >
                                    {this._renderText("item_8")}
                                </div>
                            </div>
                            <div className={Styles.progressContainerItem}>
                                {
                                    this.state.step < 5 &&
                                    <div
                                        className={
                                            cx(Styles.progressContainerItemCircle,
                                                {
                                                    [Styles.progressContainerItemCircleActive]: this.state.step === 4
                                                })
                                        }
                                    />
                                }
                                {
                                    this.state.step > 4 &&
                                    <img className={Styles.progressContainerItemIcon}
                                         src={require("../../assets/images/checkmark_active.svg")}/>
                                }
                                <div
                                    className={
                                        cx(Styles.progressContainerItemText,
                                            {
                                                [Styles.progressContainerItemTextActive]: this.state.step === 4,
                                            })
                                    }
                                >
                                    {this._renderText("item_4")}
                                </div>
                            </div>
                            <div className={Styles.progressContainerItem}>
                                <div
                                    className={
                                        cx(Styles.progressContainerItemCircle,
                                            {
                                                [Styles.progressContainerItemCircleActive]: this.state.step === 5
                                            })
                                    }
                                />
                                <div
                                    className={
                                        cx(Styles.progressContainerItemText,
                                            {
                                                [Styles.progressContainerItemTextActive]: this.state.step === 5,
                                            })
                                    }
                                >
                                    {this._renderText("item_5")}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.buttonContainer}>
                        <div className={Styles.languageButtonContainer}>
                            <div onClick={() => this.setState({dropdown: !this.state.dropdown})} className={Styles.languageButton}>
                                {this.state.lang}
                            </div>
                            {
                                this.state.dropdown &&
                                <div>
                                    <div className={Styles.languageButtonDropdown}>
                                        {
                                            this.state.languages.map((item) => {
                                                return(
                                                    <div onClick={() => this._setLang(item.code)} className={Styles.languageButtonDropdownItem}>
                                                        {item.names[langRegister.lang()]}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    <div className={Styles.languageButtonTriangle}/>
                                </div>
                            }
                        </div>
                        {
                            this.state.user.email && !this.state.user.reseller && !this.state.user.inhouse &&
                            <img onClick={() => this.setState({leave: true, profile: true})} className={Styles.buttonContainerUserIcon} src={require("../../assets/images/user_icon.svg")}/>
                        }
                        {
                            this.state.user.email && (this.state.user.reseller || this.state.user.inhouse) &&
                            <img onClick={() => this.setState({leave: true, profile: true})} className={Styles.buttonContainerUserIcon} src={require("../../assets/images/user_icon_reseller.svg")}/>
                        }
                        {
                            !this.state.user.email &&
                            <div onClick={() => this._login()} className={Styles.buttonContainerSignIn}>
                                {this._renderText("item_6")}
                            </div>
                        }
                        {
                            this.state.user.email &&
                            <div onClick={() => this._signout()} className={Styles.buttonContainerSignIn}>
                                {this._renderText("item_7")}
                            </div>
                        }
                        <img onClick={() => this._openMenu()} className={Styles.buttonContainerMobileMenu} src={require("../../assets/images/menu_icon.svg")}/>
                    </div>
                    <HeaderMobileMenu props={this.props.props} ref={instance => {this.child = instance}} layout={true}/>
                </div>
            </div>
        );
    }
}

export default HeaderSignUpTwo;


// WEBPACK FOOTER //
// ./src/components/header-signup-two/component.js